import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import { Card, Box, Button, Tabs, Tab, Typography } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import Accepted from "../../features/promocodes/Accepted";
import Rejected from "../../features/promocodes/Rejected";
import Category from "../../features/category/Category";
import {
  useLazyDeleteTutorByIdQuery,
  useLazyGetAllTutorListingQuery,
} from "../../services/tutor";
import { errorToast, successToast } from "../../helpers";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";

const ManageSubjectCategory = () => {
  return (
    <MainContainer>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">Manage Category</h1>
        </div>
        <Card className="cards">
          <Box className="custom_tabs">
            <Category />
          </Box>
        </Card>
      </div>
    </MainContainer>
  );
};

export default ManageSubjectCategory;
